import { z } from "zod";
import { TranslationSchema } from "@/utils/i18n";

export namespace Auth {
  const ConfigSchema = z.object({
    api: z.object({
      signUp: z.string(),
      signIn: z.string(),
      passwordRecovery: z.string(),
      passwordReset: z.string(),
      getHeaderButtons: z.string(),
    }),

    links: z.object({
      signUp: z.string(),
      signIn: z.string(),
      passwordRecovery: z.string(),
      passwordReset: z.string(),
    }),

    turnstile: z.object({
      sitekey: z.string(),
    }),

    google: z.object({
      href: z.string(),
    }),

    apple: z.object({
      href: z.string(),
    }),

    translation: TranslationSchema,
  });

  export type Config = z.infer<typeof ConfigSchema>;

  export type View = "sign-up" | "sign-in" | "password-recovery";

  export interface DialogProps {
    config: Config;
    view: View;
    onClose?: () => void;
    onSuccess?: (response: Response) => void;
  }

  export const ResponseSchema = z.object({
    subscriptions: z.object({
      search: z.boolean(),
    }),
    redirectUrl: z.string().optional(),
  });

  export type Response = z.infer<typeof ResponseSchema>;

  export const SocialAuthResponseSchema = z.object({
    type: z.literal("social-auth"),
    data: ResponseSchema,
  });

  export type SocialAuthResponse = z.infer<typeof SocialAuthResponseSchema>;

  export namespace Form {
    type FieldNames<
      FormName extends string,
      FormStruct,
    > = `${FormName}[${Extract<keyof FormStruct, string>}]`;

    export type FormData<FormName extends string, FormStruct> = Record<
      FieldNames<FormName, FormStruct>,
      string | number | boolean
    > & {
      _csrf: string;
    };
  }
}
